import { EXERCISE_KEY } from '../../constants'
import { MUSCLE } from '../../../../muscles'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getMusclesExerciseUtil (exercise) {
  return getValueReduxUtil(exercise, EXERCISE_KEY.MUSCLES) || [MUSCLE.ABS]
}

export { getMusclesExerciseUtil }
